import React from "react";
import { FaArrowRight, FaExternalLinkAlt, FaGithub, FaYoutube } from "react-icons/fa";

function Tile({ tile }) {
  const primaryActionLabel = tile.CtaLabel || "Read more";
  const hasPrimaryLink = Boolean(tile.PrimaryUrl);

  return (
    <article className="tile containertiles">
      <div className="tileimages tile-banner">
        <div className="tile-badges">
          <span className="tile-category">{tile.BlogType}</span>
          <span className="tile-source">{tile.Source}</span>
        </div>
        <p className="tile-banner-title">{tile.Title}</p>
      </div>
      <div className="tile-content">
        <p className="tile-description">{tile.Description}</p>
        <div className="tile-footer">
          <div className="tile-buttons">
            {tile.GitHubRepo && (
              <button
                className="tile-button"
                onClick={() => window.open(tile.GitHubRepo, "_blank", "noopener,noreferrer")}
                aria-label="Open GitHub repository"
              >
                <FaGithub className="tile-icon tile-icon-github" />
              </button>
            )}
            {tile.YouTubeUrl && (
              <button
                className="tile-button"
                onClick={() => window.open(tile.YouTubeUrl, "_blank", "noopener,noreferrer")}
                aria-label="Open YouTube video"
              >
                <FaYoutube className="tile-icon tile-icon-youtube" />
              </button>
            )}
            {hasPrimaryLink && (
              <button
                className="tile-link"
                onClick={() => window.open(tile.PrimaryUrl, "_blank", "noopener,noreferrer")}
              >
                {primaryActionLabel}
                <FaArrowRight className="tile-link-arrow" />
              </button>
            )}
          </div>
          {hasPrimaryLink && (
            <div className="tile-meta-link">
              <FaExternalLinkAlt className="tile-meta-icon" />
              <span>{tile.Source}</span>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

export default Tile;
